import React from 'react';
import App from './App';

import { configureSentry } from '@shared/modules/sentry/utils';

import '@styles/css';
import { createRoot } from 'react-dom/client';

configureSentry();

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(<App />);
}
